import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as flexboxHelpersStyles } from '../../../assets/flexbox-helpers.scss';
import { styles as styleHelpers } from '../../../assets/style-helpers.scss';
import { styles as textHelpersStyles } from '../../../assets/text-helpers.scss';

export const templateIncidentsActivityPanel = document.createElement('template');

templateIncidentsActivityPanel.innerHTML = `
  <style>${flexboxHelpersStyles}</style>
  <style>${styleHelpers}</style>
  <style>${textHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="wrapper">

    <div class="d-flex flex-column flex-1 panel-container h-full" id="incidentsActivityContainer">
        <div class="d-flex flex-row align-items-center pt-2 justify-center pr-3">
          <gz-title fontSize="11" fontWeight="600" class="flex-1 title"></gz-title>
          <gz-icon-button id="collapseBtn" icon="ds-icon-arrow_left_collapse" size="32" fontsize="20" buttontype="square" buttonfill="quiet" buttoncolor="secondary"></gz-icon-button>
        </div>
        <gz-time-range-slider class="pt-2 pr-3"></gz-time-range-slider>
        <gz-single-select class="pt-2 pr-3"></gz-single-select>
        <gz-input-search class="pt-2 pb-2 pr-3"></gz-input-search>
        <gz-timeline class="pr-1 mr-2 mb-1" headerSlotEvent allowMultipleOpen></gz-timeline>
    </div>

     <div class="collapsed-container pt-2 d-flex justify-center align-items-center" id="uncollapsBtn">
        <gz-icon-button icon="ds-icon-arrow_right_expand" size="32" fontsize="20" buttontype="square" buttonfill="quiet" buttoncolor="secondary"></gz-icon-button>
     </div>
 </div>
`;
